import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    alarms: [],
    loading: false,
    error: null,
    paginationInfo: null,
    currentPageNumber: 1,
    currentPageSize: 25,
};
const alarmNotificationsSlice = createSlice({
    name: "alarmNotifications",
    initialState,
    reducers: {
        addAlarmNotification: (state, action) => {
            const existingIndex = state.alarms.findIndex((a) => a.id === action.payload.id);
            if (existingIndex === -1) {
                const mappedAlarm = {
                    id: action.payload.id,
                    nodeUid: action.payload.nodeUid,
                    accessPointUid: action.payload.accessPointUid,
                    alarmType: action.payload.alarmType,
                    temperature: action.payload.temperature,
                    threshold: action.payload.threshold,
                    alertType: action.payload.alertType,
                    isAlarmAcknowledged: action.payload.isAlarmAcknowledged,
                    alarmStartDateTime: action.payload.alarmStartDateTime,
                    alarmEndDateTime: action.payload.alarmEndDateTime,
                    acknowledgedBy: action.payload.acknowledgedBy,
                    nodeName: action.payload.nodeName,
                    accessPointName: action.payload.accessPointName,
                };
                state.alarms.unshift(mappedAlarm);
            }
        },
        updateAlarmNotification: (state, action) => {
            const index = state.alarms.findIndex((a) => a.id === action.payload.id);
            if (index !== -1) {
                state.alarms[index] = Object.assign(Object.assign({}, state.alarms[index]), action.payload);
            }
        },
        setAlarms: (state, action) => {
            state.alarms = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setPaginationInfo: (state, action) => {
            state.paginationInfo = action.payload;
        },
        setPageNumber: (state, action) => {
            state.currentPageNumber = action.payload;
        },
        setPageSize: (state, action) => {
            state.currentPageSize = action.payload;
            state.currentPageNumber = 1;
        },
        resetFiltersAndPagination: (state) => {
            state.currentPageNumber = 1;
            state.currentPageSize = 25;
        },
    },
});
export const { addAlarmNotification, updateAlarmNotification, setAlarms, setLoading, setError, setPaginationInfo, setPageNumber, setPageSize, resetFiltersAndPagination, } = alarmNotificationsSlice.actions;
export default alarmNotificationsSlice.reducer;
